import { render, staticRenderFns } from "./marchesi-antinori.vue?vue&type=template&id=e2bc73e6&scoped=true"
import script from "./marchesi-antinori.vue?vue&type=script&lang=js"
export * from "./marchesi-antinori.vue?vue&type=script&lang=js"
import style0 from "./marchesi-antinori.vue?vue&type=style&index=0&id=e2bc73e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bc73e6",
  null
  
)

export default component.exports